import {useContext} from 'react'

import PropTypes from 'prop-types'

import {AuthenticationContext} from '@adv-mt/mt-context-authentication'

import {MessagingProvider} from './context.js'
import {getInitialProps} from './getInitialProps.js'
import UserMessagesPage from './page.js'

const UserMessagesWrapper = ({authToken, pageTrackingData}) => {
  const {user} = useContext(AuthenticationContext)
  const userData = user || {}

  return (
    <MessagingProvider>
      <UserMessagesPage authToken={authToken} pageTrackingData={pageTrackingData} userData={userData} />
    </MessagingProvider>
  )
}
UserMessagesWrapper.displayName = 'UserMessagesWrapper'
UserMessagesWrapper.getInitialProps = getInitialProps
UserMessagesWrapper.propTypes = {
  authToken: PropTypes.string,
  pageTrackingData: PropTypes.object
}
UserMessagesWrapper.keepMounted = true

export default UserMessagesWrapper
